import { render, staticRenderFns } from "./primeiro-diagnostico-badge.vue?vue&type=template&id=1b84880a&scoped=true"
import script from "./primeiro-diagnostico-badge.vue?vue&type=script&lang=ts"
export * from "./primeiro-diagnostico-badge.vue?vue&type=script&lang=ts"
import style0 from "./primeiro-diagnostico-badge.vue?vue&type=style&index=0&id=1b84880a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b84880a",
  null
  
)

export default component.exports